import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getSetVariableTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'add-variable',
			selector: '[data-tour="add-variable"]',
			content: 'Clicking this button allows you to add a variable to the task.',
		},
		{
			id: 'variable-type',
			selector: '[data-tour="variable-type"]',
			content:
				'The type of variable being added to the task, it can either be a flow variable or a record variable.',
		},
		{
			id: 'variable-name',
			selector: '[data-tour="variable-name"]',
			content: 'Provide a name for the variable to be added to the task.',
		},
		{
			id: 'variable-value',
			selector: '[data-tour="variable-value"]',
			content:
				'Provide a value for the newly created variable, alternatively press "ctrl+space" to open the expression selector to be able to select pre-existing expressions for the value, such as the date and time.',
		},
		{
			id: 'variable-delete',
			selector: '[data-tour="variable-delete"]',
			content: 'You may also delete a variable from the task if it is no longer needed or in use.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
